import { sendEmailQuoteEvent } from 'core/services/email/blueshift/implementations/email-quote'
import makeComparisonPayload from 'core/services/email/sendEmailFromAgent/comparison/makePayload'
import sendEmailFromAgent from 'core/services/email/sendEmailFromAgent'
import store from 'utils/store/withMiddleware'
import config from './config'

function comparePlansFromAgent(salesCenterAgent, valuesForm, agentInformation) {
  const state = store.getState()
  const data = makeComparisonPayload({
    valuesForm,
    agentInformation,
    plans: state.plansToShow.map(id => state.plansData[id]),
    salesCenterAgent,
    placement: config.placement
  })

  const quote = data.message.global_merge_vars.find(
    item => item.name === 'linkToQuote'
  ).content

  sendEmailQuoteEvent(quote)

  sendEmailFromAgent({
    config,
    data
  })
}

export default comparePlansFromAgent
